<template>
    <Teleport to="#gocardless-payment-method-vue-app">
        <div class="gocardless-payment-method pt-1">
            <template v-if="!customerAccount">
                <div class="alert alert-danger">
                    {{ l('GOCARDLESS.NO_CUSTOMER') }}
                </div>
            </template>
            <template v-else>
                <div class="gocardless-payment-method__top">
                    <div class="gocardless-payment-method__header mb-1">
                        <img class="flex--no-grow flex--no-shrink"
                             src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNTAgNTAiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCI+PHBhdGggZD0iTSAyMy41MjkyOTcgOSBDIDExLjEwOTI5NyA5IDEgMTYuNCAxIDI1LjUgQyAxIDM0LjYgMTEuMTA5Mjk3IDQyIDIzLjUyOTI5NyA0MiBMIDI4LjQ5MDIzNCA0MiBDIDQwLjE4MDIzNCA0MS4yNCA0OSAzNC4xNSA0OSAyNS41IEMgNDkgMTcuNDUgNDEuMzYwODU5IDEwLjc1IDMwLjg4MDg1OSA5LjI1IEMgMzAuODYwODU5IDkuMjUgMzAuODQwMzEyIDkuMjQwMjM0NCAzMC44MjAzMTIgOS4yNDAyMzQ0IEMgMzAuMDkwMzEyIDkuMTQwMjM0NCAyOS4zMzAzMTMgOS4wNSAyOC41NzAzMTIgOSBMIDI4LjQ5MDIzNCA5IEwgMjguNDI5Njg4IDkuOTE5OTIxOSBMIDI4LjM1OTM3NSAxMSBDIDI5LjEwOTM3NSAxMS4wNSAyOS44NTAzMTMgMTEuMTMwMjM0IDMwLjU3MDMxMiAxMS4yNDAyMzQgQyAzMC42NDAzMTIgMTEuMjUwMjM0IDMwLjcxOTA2MiAxMS4yNTkyOTcgMzAuNzg5MDYyIDExLjI3OTI5NyBDIDM2LjExOTA2MiAxMi41MzkyOTcgNDAuMTUwMzkxIDE3Ljk5IDQwLjE1MDM5MSAyNC41IEMgNDAuMTUwMzkxIDI4LjYyMSAzOC4wMDAyMzQgMzUuOTk5MDMxIDMxLjExNTIzNCAzOC45NTcwMzEgQyAyOS44NzcyMzQgMzkuNDg5MDMxIDI4LjYyOTI1IDQwIDI3LjI4MTI1IDQwIEwgMjQuNTA5NzY2IDQwIEMgMTQuODY5NzY2IDQwIDcuODkwNjI1IDM0LjA4OTM3NSA3Ljg5MDYyNSAzMC4xMDkzNzUgQyA3Ljg5MDYyNSAyNi4xMzkzNzUgMTUgMjAuOTk5NTMxIDI2IDIxLjAxOTUzMSBMIDI2IDkgTCAyMy41MjkyOTcgOSB6IE0gMjYgMjIuMDI5Mjk3IEMgMTkuOSAyMi4zNTkyOTcgMTMuNzIwNzAzIDI1Ljc5MDA3OCAxMy43MjA3MDMgMzAuNTgwMDc4IEMgMTMuNzIwNzAzIDM1LjI3MDA3OCAxNy45IDM4LjYxMDcwMyAyNCAzOC45NzA3MDMgQyAyNC4zNSAzOC45OTA3MDMgMjQuNzE5ODQ0IDM5IDI1LjA4OTg0NCAzOSBMIDI2IDM5IEwgMjYgMjIuMDI5Mjk3IHoiLz48L3N2Zz4="
                             alt="Direct Debit Logo" />

                        <div class="flex--grow ml-05 mr-1">
                            <!-- Max width div used to wrap the text at a nice place in on wide screens -->
                            <div class="pretty-wrap"
                                 style="max-width: 465px">
                                {{ l('GOCARDLESS.PAY_SUBTITLE') }}
                            </div>

                            <template v-if="cartLinesWithRepeatingPaymentDescriptions">
                                <!-- List of payment descriptions being created. -->
                                <div>
                                    {{ l('GOCARDLESS.PAY_SUBTITLE_2') }}
                                </div>
                                <ul class="pl-2">
                                    <li v-for="cartLine in cartLinesWithRepeatingPaymentDescriptions"
                                        :key="cartLine.ID">
                                        <small>
                                            <strong>{{ cartLine.quantity }}x</strong>
                                            {{ cartLine.paymentDescription }}
                                        </small>
                                    </li>
                                </ul>
                            </template>
                        </div>

                        <div class="flex--no-grow flex--no-shrink">
                            <SquareBtn size="lg"
                                       class="flex--no-grow flex--no-shrink px-1"
                                       @click="addNewAccount">
                                <i class="fa-solid fa-plus"></i> {{ l('GOCARDLESS.ADD_BANK_ACCOUNT') }}
                            </SquareBtn>
                        </div>
                    </div>

                    <CustomerGoCardlessPaymentTokens ref="payment-tokens"
                                                     v-model:selected-payment-token="selectedPaymentToken"
                                                     :selectable="true"
                                                     :customer-account-i-d="customerAccount.ID" />
                </div>
                <div class="payment-modal__payment-controls">
                    <SquareBtn color="primary"
                               size="lg"
                               :visually-disabled="!selectedPaymentToken"
                               block
                               @click="okPressed">
                        <i class="fa-solid fa-circle-check"></i>
                        {{ l('GOCARDLESS.CONTINUE_BTN') }}
                    </SquareBtn>
                </div>
            </template>
        </div>
    </Teleport>
</template>

<script>
import CustomerGoCardlessPaymentTokens from '@/epos/vue/modals/ManageGoCardless/CustomerGoCardlessPaymentTokens';
import EventNames from '@/lib/Events/EventNames';
import Payment from '@/lib/Payments/Payment';
import PaymentMethodRef from '@/lib/PaymentMethods/PaymentMethodRef';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';

export default {
    components: {
        SquareBtn,
        CustomerGoCardlessPaymentTokens,
    },

    data() {
        return {
            /**
             * @type {?PaymentToken}
             */
            selectedPaymentToken: null,

            paymentMethod: null,
        };
    },

    computed: {
        /**
         * @return {CartLine[]}
         */
        cartLinesWithRepeatingPaymentDescriptions() {
            return container.cartService.currentCart
                .getLines()
                .filter((cl) => cl.isRepeatingPayment() && cl.paymentDescription);
        },

        customerAccount() {
            return container.cartService.currentCart.customer?.account || null;
        },
    },

    created() {
        // Get the payment method for this payment method component.
        this.paymentMethod = container.paymentMethodService.getByRef(PaymentMethodRef.GOCARDLESS);
    },

    methods: {
        /**
         * @returns {Promise<void>}
         */
        async addNewAccount() {
            try {
                const newPaymentToken = await container.vueModalFactory.open(
                    MODAL_NAMES__EPOS.ADD_GOCARDLESS_BANK_ACCOUNT,
                    {
                        customerAccount: this.customerAccount,
                    },
                );

                // Update the list of payment tokens.
                await this.$refs['payment-tokens'].loadPaymentTokens();

                // Select the newly added payment token by its payment token ID.
                this.selectedPaymentToken = this.$refs['payment-tokens'].paymentTokens.find(
                    (paymentToken) => paymentToken.ID === newPaymentToken.customerAccountPaymentTokenID,
                ) || null;
            } catch {
                // Cancelled — do nothing.
            }
        },

        okPressed() {
            // Ensure a mandate is selected.
            if (!this.selectedPaymentToken) {
                container.toastFactory.warningTop('PAYMENT_GOCARDLESS.NO_MANDATE_SELECTED');
                return;
            }

            // A mandate (payment token) was selected. Add the payment to the order.
            // This isn't a real payment, it's more of a promise that the payment will be taken later by GoCardless.
            const paymentAmount = container.cartService.getRemainingMaxPayment();
            const payment = new Payment();
            payment.setPaymentMethod(this.paymentMethod);
            payment.setTendered(paymentAmount);
            payment.setChangeGiven(0);
            payment.setValue(paymentAmount);
            payment.setPaymentTokenID(this.selectedPaymentToken.ID);
            payment.setThirdPartyID(container.cartService.generatePaymentThirdPartyID());
            payment.pending = 1;
            payment.paid = false;

            container.eventBus.broadcast(EventNames.ADD_PAYMENT_TO_CART_REQUESTED, payment);
        },
    },
};
</script>

<style lang="less">
@import '../../../../../../less/variables.less';

.dt-payment-method[data-payment-method-ref="bank-gocardless-jsflow-bacs"] {
    // Set 100% height on the payment method within the Angular ng-for loop.
    height: 100%;
    min-height: 0;
}

.gocardless-payment-method {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: @gutter-width;

    &__header {
        display: flex;
        align-items: center;

        img {
            width: 48px;
            height: 48px;
        }
    }

    &__top {
        flex-grow: 1;
        flex-shrink: 1;
        overflow: auto;
        min-height: 0;
    }

    &__bottom {
        flex-grow: 0;
        flex-shrink: 1;
    }
}
</style>
